import { gql } from 'graphql-request'

export const LOGIN_WITH_NAIIN = gql`
  mutation LoginWithNaiin($loginWithNaiinInput: LoginWithNaiinInput!) {
    loginWithNaiin(loginWithNaiinInput: $loginWithNaiinInput) {
      token
    }
  }
`
